module.exports = __webpack_public_path__ + "static/media/marker-red.224b0ab7.png";